import {SET_TAX_FORMS_COUNTRIES_ACTION, SET_TAX_FORMS_DATE_RANGE_ACTION, SET_DIRTY_COUNTRY_SELECTION_ACTION, TaxFormsAction} from '../actions/tax-forms.actions';
import {DateModel} from '../../models/tax-forms.model';


export class TaxFormsState {
  countries: any[];
  dateFilter: DateModel;
  isCustomCountrySelected: boolean;
}

const initialState: TaxFormsState = <TaxFormsState>{
  countries: [],
  dateFilter: new DateModel({
    fromDate: ((new Date()).getFullYear()).toString() + '-01-01T00:00:00Z',
    toDate: ((new Date()).getFullYear()).toString() + '-12-31T00:00:00Z',
    fromDateValue: new Date(`${(new Date().getFullYear())}-01-01`),
    toDateValue: new Date(`${(new Date().getFullYear())}-12-31`)
  }),
  isCustomCountrySelected: false
};

export function taxFormsReducer(state = initialState, action: TaxFormsAction): TaxFormsState {
  switch (action.type) {
    case SET_TAX_FORMS_COUNTRIES_ACTION:
      return {
        ...state,
        countries: action.countries
      };
    case SET_TAX_FORMS_DATE_RANGE_ACTION:
      return {
        ...state,
        dateFilter: action.dateInfo
      };
    case SET_DIRTY_COUNTRY_SELECTION_ACTION:
      return {
        ...state,
        isCustomCountrySelected: action.dirtyCountrySelection
      };
    default:
      return state;
  }
}
